import React from "react";

function Interviews() {
  return (
    <div className="interviews">
      <div className="tag_btn wow fadeInUp">Product Demo</div>
      <div className="t f_24 wow fadeInUp">Master Your Case Interviews</div>
      <div className="des wow fadeInUp">
        Real-time, humanlike mock interviews with expert feedback—tailored just
        for you.
      </div>
      <div className="content">
        <div className="item wow fadeInUp">
          <div
            className="l"
            style={{
              width: "46.09375vw",
              height: "25.9375vw",
              borderRadius: "16px",
              border: "0.5px solid #e2e2e2",
              background: "#fff",
              boxShadow: "0px 0px 12px 4px rgba(238, 238, 238, 0.25)",
              overflow: "hidden",
            }}
          >
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/RMfYn-MchC4?autoplay=1&mute=1&loop=1&playlist=RMfYn-MchC4"
              title="WeKruit Interview Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ border: "none" }}
            ></iframe>
          </div>
          <div className="r">
            <div className="icon">
              <img src="./images/people.svg" alt="" />
            </div>
            <p className="pt f_32">Your Own Interviewer</p>
            <div className="des">
              Enjoy lifelike interview simulations anytime with our innovative
              multi-agent system that adapts to your pace. Experience a
              comfortable, low-pressure environment focused on your growth, with
              your personal interviewer available{" "}
              <span className="color_blue">24/7</span>.
            </div>
          </div>
        </div>
        <div className="item wow fadeInUp">
          <div
            className="l"
            style={{
              width: "46.09375vw",
              height: "25.9375vw",
              borderRadius: "16px",
              border: "0.5px solid #e2e2e2",
              background: "#fff",
              boxShadow: "0px 0px 12px 4px rgba(238, 238, 238, 0.25)",
              overflow: "hidden",
            }}
          >
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/gGWu7tGaaho?autoplay=1&mute=1&loop=1&playlist=gGWu7tGaaho"
              title="WeKruit Performance Report Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ border: "none" }}
            ></iframe>
          </div>
          <div className="r">
            <div className="icon">
              <img src="./images/book.svg" alt="" />
            </div>
            <p className="pt f_32">
              Customized Performance
              <br /> Report
            </p>
            <div className="des">
              Right after your interview, receive a tailored, actionable
              report—just like a in-depth debrief from a seasoned industry
              expert, validated by MBB interviewers with{" "}
              <span className="color_red">15+ years</span> of experience.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Interviews;
